<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Courses',
  methods: {
    ...mapMutations('ui', [
      'setSearch',
    ]),
  },
  created() {
    this.setSearch({
      placeholder: 'Enter at least 2 characters to search courses by title',
      route: 'courses-listing',
    });
  },
};
</script>
<style lang="scss" scoped>
@import '../../styles/_variables.scss';
nav {
  h3 {
    font-size: $font-size-h4 * .75;
    color: map-get($colors, outerSpace);
  }
}
</style>
<template>
  <div class="h-100">
    <div class="container-fluid h-100">
      <router-view />
    </div>
  </div>
</template>
